var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M50 49.9999C61.5059 49.9999 70.8333 40.6725 70.8333 29.1666C70.8333 17.6607 61.5059 8.33325 50 8.33325C38.4941 8.33325 29.1667 17.6607 29.1667 29.1666C29.1667 40.6725 38.4941 49.9999 50 49.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 79.1667C58.3333 82.125 58.9583 84.9583 60.0417 87.5H25C18.0833 87.5 12.5 81.9167 12.5 75C12.5 68.0833 18.0833 62.5 25 62.5H66.6667C61.625 66.2917 58.3333 72.375 58.3333 79.1667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M79.1667 58.3333C74.4792 58.3333 70.15 59.8833 66.6667 62.4999C58.3333 62.4999 50 79.1666 50 79.1666C50 79.1666 54.1667 83.3333 59.9708 87.2749C63.1333 94.7499 70.5417 99.9999 79.1667 99.9999C90.6667 99.9999 100 90.6666 100 79.1666C100 67.6666 90.6667 58.3333 79.1667 58.3333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0833 77.5834L79.6667 88.0001C78.9583 88.6668 78.0417 89.0834 77.0833 89.0834C76.125 89.0834 75.2083 88.6668 74.5 88.0001L68.25 81.7501C66.8333 80.3334 66.8333 78.0001 68.25 76.5834C69.6667 75.1667 72 75.1667 73.4167 76.5834L77.0833 80.2501L84.9167 72.4167C86.3333 71.0001 88.6667 71.0001 90.0833 72.4167C91.5 73.8334 91.5 76.1668 90.0833 77.5834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.236664da832535701709aee0bf78c1d2.svg";
export { ForwardRef as ReactComponent };